import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import SupplierOrderIndexPage from '../containers/SupplierOrders'

import appActions from '../redux/app/actions'

const { changeCurrent } = appActions

const SupplierOrdersPage = ({
  location,
	match
}) => {
  const dispatch = useDispatch()
	const current = useSelector(state => state.getIn(['App', 'current'])).toJS()
	const { pathname } = location

	useEffect(() => {
		if (current[0] !== 'supplier_orders') {
			dispatch(changeCurrent(['supplier_orders']))
		}
	}, [pathname])

	const path = match.url

  return (
		<Switch>
			<Route path={`${path}/`} component={SupplierOrderIndexPage} exact />
		</Switch>
  )
}

SupplierOrdersPage.propTypes = {
  location: PropTypes.object.isRequired,
	match: PropTypes.object.isRequired
}

SupplierOrdersPage.defaultProps = {}

export default SupplierOrdersPage
